<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [
        { name: "合同管理" },
        { name: "合同列表" },
      ],
      menuIndex: '/order/contract/own/tobe',
      menu: [
        {
          name: "待派单",
          path: '/contract/list/tobe',
        },
        {
          name: "运送中",
          path: '/contract/list/ing',
        },
        {
          name: "待审核",
          path: '/contract/list/uncheck',
        },
        {
          name: "已完成",
          path: '/contract/list/done',
        },
      ],
    };
  },
  methods: {},
  watch: {
    $route() {
      this.menuIndex = this.$route.path
    },
  },
  mounted() {
    this.menuIndex = this.$route.path
  },
};
</script>
